import PrimaryButton from 'components/button/PrimaryButton';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import { theme } from 'utils/style/theme';
import styled from 'styled-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputWrappingBox from 'components/container/InputWrappingBox';
import { Checkbox, message } from 'antd';
import { handleMessage } from 'utils/helper/message';
import { useNavigate } from 'react-router-dom';
import InputStyled from 'components/InputStyled';
import refreshPage from 'utils/helper/refreshPage';
import UploadImage from '../Content/UploadImage';
import { loadingApis } from 'apis/story/loadingApis';

interface IProps {
  data: any | null;
  setData: React.Dispatch<React.SetStateAction<any | null>>;
  projectId: string | undefined;
}

export interface IVisible {
  create: boolean;
  edit: boolean;
}

const FormRightContent: React.FC<IProps> = ({ data, setData, projectId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (data) {
      try {
        await loadingApis.loadingUpdateInfor(projectId, data.id, data);
        handleMessage(message, 'success', 'Success');
        refreshPage();
      } catch (err) {
        handleMessage(message, 'error', 'Please try again');
      }
    }
  };
  const handleCancel = () => {
    navigate(-1);
  };

  const handleOnChange = (value, type) => {
    const cloneData = JSON.parse(JSON.stringify(data));
    cloneData[type] = value;
    setData(cloneData);
  };

  return (
    <>
      <InputWrappingBox>
        <Wrapper>
          <SectionWarpper>
            <div className='header'>
              <p>
                {t(
                  'storyEpisodeID.storyTabMenuList.loadingContent.update.loadingId',
                )}
                : <span>{data?.id}</span>
              </p>
            </div>
            <div>
              <p className='title'>
                {t(
                  'storyEpisodeID.storyTabMenuList.loadingContent.update.loadingImage',
                )}
                :
              </p>
              <InputStyled
                value={data?.loading_name}
                onChange={(e) => {
                  handleOnChange(e.target.value, 'loading_name');
                }}
                maxLength={30}
              />
              <p className='length-subtext'>
                {typeof data?.loading_name?.length === 'number'
                  ? `${data?.loading_name?.length}/30 characters`
                  : '0/30 characters'}
              </p>
            </div>
            <div>
              <p className='title'>
                {t(
                  'storyEpisodeID.storyTabMenuList.loadingContent.update.loadingImage',
                )}
                :{' '}
              </p>
              <UploadImage
                data={data}
                setData={setData}
                projectId={projectId}
                type='image'
              />
            </div>
          </SectionWarpper>
        </Wrapper>
      </InputWrappingBox>
      <SubmitFlexBox style={{ columnGap: 12, marginTop: '24px' }}>
        <>
          <PrimaryButton
            text={t('updateStory.form.buttonCancel')}
            height='40px'
            width='151px'
            bgColor='#FFFF'
            textColor={theme.colors.dark_400}
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.gray_6}`}
            rounded='6px'
            hoverBgColor={'#FFFF'}
            activeBgColor={'#FFFF'}
            selectedBgColor={'#FFFF'}
            onClick={handleCancel}
          />
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='151px'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
          />
        </>
      </SubmitFlexBox>
    </>
  );
};

export default FormRightContent;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header p {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_500};
  }
  .header p span {
    font-weight: ${theme.fontWeights.bold};
  }
  .fixed {
    display: flex;
    align-items: center;
    justify-content: center;
    & > * + * {
      margin-left: 10px;
    }
  }
  .condition {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > * + * {
      margin-left: 16px;
    }
  }
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 24px;
  }
  .ant-input-disabled {
    color: ${theme.colors.dark_300};
  }
`;

const CheckboxStyled = styled(Checkbox)`
  .ant-checkbox .ant-checkbox-input {
    cursor: default;
  }
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border: 1px solid #d9d9d9;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 1rem;
  }
`;

const CheckboxSection = styled.div`
  display: flex;
  & > * + * {
    margin-left: 24px;
  }
`;
